
const INQUIRY_STATUS = {
  NEW: 1,
  CONTINUE: 2,
  ANSWERED: 3,
};

// 管理者（CMS）表示ラベル
const CMS_INQUIRY_STATUS_TEXTS = {
  [INQUIRY_STATUS.NEW]: '新規',
  [INQUIRY_STATUS.CONTINUE]: '継続',
  [INQUIRY_STATUS.ANSWERED]: '回答済み',
};

// 申請者（GAS）表示ラベル
const GAS_INQUIRY_STATUS_TEXTS = {
  [INQUIRY_STATUS.NEW]: '問合せ中',
  [INQUIRY_STATUS.CONTINUE]: '継続中',
  [INQUIRY_STATUS.ANSWERED]: '回答あり',
};

// 投稿区分（mst_inquiry_messages.sender_category・backend と一致）
const INQUIRY_SENDER_CATEGORY = {
  APPLICANT: 1, // 申請者
  ADOPTEE: 2, // 採択者
  AGENT: 3, // 代行者（No.9 (B)：採択者に代わって投稿した人）
};

// 区分の表示ラベル
const INQUIRY_SENDER_CATEGORY_TEXTS = {
  [INQUIRY_SENDER_CATEGORY.APPLICANT]: '申請者',
  [INQUIRY_SENDER_CATEGORY.ADOPTEE]: '採択者',
  [INQUIRY_SENDER_CATEGORY.AGENT]: '代行者',
};

export default {
  INQUIRY_STATUS,
  CMS_INQUIRY_STATUS_TEXTS,
  GAS_INQUIRY_STATUS_TEXTS,
  INQUIRY_SENDER_CATEGORY,
  INQUIRY_SENDER_CATEGORY_TEXTS,
};
